export default __webpack_public_path__ + "static/media/aceleraBanner.dddea744.jpg";